import React from 'react';

export default function WorkTypeTabBar({
  details,
  currentTab,
  onTabChange,
  witnessSignStatusMap,
}) {
  return (
    <section className="sticky top-0 z-40 -mx-5 border-b border-[#becab7]/10 bg-[#f8f9fb]/95 px-5 backdrop-blur-sm">
      <div className="no-scrollbar flex gap-1 overflow-x-auto">
        {details?.map((item) => {
          const workItemId = String(item.workItemId);
          const isSelected = String(currentTab) === workItemId;
          const hasWitnessSign = witnessSignStatusMap?.[workItemId];
          const needsWitnessSign =
            witnessSignStatusMap && hasWitnessSign === false;

          return (
            <button
              key={item.dtlCd}
              onClick={() => onTabChange(workItemId)}
              className={`flex-none rounded-full px-5 py-2 text-xs font-bold transition-all duration-200 ${
                isSelected
                  ? 'bg-[#5ABD4F] text-white shadow-lg shadow-[#5ABD4F]/20'
                  : needsWitnessSign
                    ? 'border border-amber-300 bg-amber-50 text-amber-700'
                    : 'border border-[#becab7]/30 bg-white text-[#3f4a3b]'
              }`}
            >
              {item.workTypeNm}
              {item?.isExtended === 'Y' && ' (연장)'}
              {witnessSignStatusMap &&
                (hasWitnessSign ? ' ✓' : ' ·서명필요')}
            </button>
          );
        })}
      </div>
    </section>
  );
}
